import Vue from 'vue'
import VueI18n from 'vue-i18n'
import de from './de'
import en from './en'

Vue.use(VueI18n)

let locale = document.documentElement.getAttribute('lang')
if (locale === '{{lang}}') {
  locale = 'de'
}

export default new VueI18n({
  locale,
  fallbackLocale: 'de',
  messages: {
    de,
    en
  }
})



// WEBPACK FOOTER //
// ./src/i18n/index.js